export const SET_LOCALE = "intl-provider/SET_LOCALE";
export const SET_LOCALE_ERRMSG = "intl-provider/SET_LOCALE_ERRMSG";

export const localeInfoMap = Object.freeze({
    "en-US": {
        messagesUrl: `/i18n/en-US.json`,
        momentLocaleName: "en",
    },
    "en-UPPER": {
        messagesUrl: `/i18n/en-UPPER.json`,
        momentLocaleName: "en",
    },
    es: {
        messagesUrl: `/i18n/es.json`,
        momentLocaleName: "es",
    },
    fr: {
        messagesUrl: `/i18n/fr.json`,
        momentLocaleName: "fr",
    },
});

export const locales = Object.keys(localeInfoMap);

export const setLocale = (locale) => {
    return {
        type: SET_LOCALE,
        payload: { locale },
    };
};

export const setLocaleError = (errMessage) => {
    return {
        type: SET_LOCALE_ERRMSG,
        payload: { errMessage },
    };
};
